module.exports = __webpack_public_path__ + "img/23.hailstrom-light.71ba7271.svg";